import styled, { css } from 'styled-components';
import { H3, H4 } from '../../font';
import { Paragraph } from '../../typographies';
import { ColorAddiPrimaryActive } from '@addi/foundation/dist/web/colors';
const flexCenter = css `
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Title = styled(H3) `
  text-align: center;
  margin: 0.5rem 0 0 0;
`;
export const Subtitle = styled(H4) `
  text-align: center;
  margin: 0;
  color: ${ColorAddiPrimaryActive};
`;
export const Description = styled(Paragraph) `
  text-align: center;
  margin: 1rem 0;
  grid-row-start: 3;
`;
export const Container = styled.section `
  width: 100%;
  height: 96vh;
  min-height: 468px;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(10, 1fr);
  grid-auto-flow: row;
  &&& button {
    align-self: bottom;
    grid-row-start: 9;
  }
`;
export const HeaderContainer = styled.header `
    ${flexCenter}
    flex-direction: ${({ reverse }) => (reverse ? 'column-reverse' : 'column')};
    grid-row-start: 2;
`;
export const TitleContainer = styled.div `
  ${flexCenter}
  flex-direction: column;
`;
export const Footnote = styled(Paragraph) `
  text-align: center;
  margin: 10px 0;
  span {
    font-size: 13px;
  }
`;
//# sourceMappingURL=StatusScreenV2.Styled.js.map